"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppAgentApprovalDecisionSchema = exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = void 0;
exports.buildInAppAgentApprovalDecisionEvent = buildInAppAgentApprovalDecisionEvent;
exports.parseInAppAgentApprovalDecisionEvent = parseInAppAgentApprovalDecisionEvent;
const core_1 = require("@ag-ui/core");
const zod_1 = require("zod");
/** Render-only approval history stored in the append-only event stream. */
exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = "langfuse_approval_decision";
exports.InAppAgentApprovalDecisionSchema = zod_1.z.object({
    toolCallId: zod_1.z.string().min(1),
    approved: zod_1.z.boolean(),
    decidedByUserId: zod_1.z.string().min(1),
});
function buildInAppAgentApprovalDecisionEvent(decision) {
    return {
        type: core_1.EventType.CUSTOM,
        name: exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME,
        value: decision,
    };
}
function parseInAppAgentApprovalDecisionEvent(event) {
    if (event.type !== core_1.EventType.CUSTOM ||
        event.name !== exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME) {
        return undefined;
    }
    const parsed = exports.InAppAgentApprovalDecisionSchema.safeParse(event.value);
    return parsed.success ? parsed.data : undefined;
}
